import { Main } from '@/components/Main';
import AddressItem from '@/views/addressItem';

// import { Main } from '@/components/Main';
// import { Main } from '@/components/Main';

const routes = [{
  path: '/mall',
  name: 'MallHome',
  component: Main,
  redirect: '/course',
  children: [
    {
      path: 'camp-throw',
      name: 'campThrow',
      component: Main,
      children: [
        {
          path: 'free-get-camp',
          name: 'freeGetCamp',
          component: () => import(/* webpackChunkName: "paySuccess" */ '../views/campThrow/freeGetCamp.vue'),
        },
        {
          path: 'free-get-camp-ok',
          name: 'freeGetCampOk',
          component: () => import(/* webpackChunkName: "paySuccess" */ '../views/campThrow/freeGetCampOk.vue'),
        }
      ]
    },
    {
      path: 'oneKeyBuyNew',
      name: 'oneKeyBuyNew',
      component: () =>
        import('@/views/oneKeyBuyNew')
    },
    {
      path: 'strategyAddWechat',
      name: 'strategyAddWechat',
      meta: {
        title: '少年得到'
      },
      component: () =>
        import('@/views/success/strategyAddWechat')
    },

    /** 新增兼容商城1.0版本功能 */
    {
      path: 'item',
      name: 'courserVersion1.0',
      component: () =>
        import(/* webpackChunkName: "courserVersion1" */ '@/views/item')
    },

    // 订单支付页
    {
      path: 'order_v1',
      name: 'OrderVersion1.0',
      meta: {
        title: '确认订单'
      },
      component: () =>
        import(/* webpackChunkName: "order" */ '../views/order/index.vue')
    },

    // 订单支付页
    {
      path: 'paySuccess',
      name: 'paySuccess',
      component: () =>
        import(/* webpackChunkName: "paySuccess" */ '../views/order/paySuccess.vue')
    },
    {
      path: 'course',
      name: 'courseItem',
      component: () =>
        import(/* webpackChunkName: "mall" */ '@/views/course')
    },
    // 组合商品活动页面
    {
      path: 'combine',
      name: 'combine',
      component: () =>
        import(/* webpackChunkName: "combine" */ '@/views/combine')
    },

    {
      path: 'shoppingPolymerize',
      name: 'shoppingPolymerize',
      meta: {
        title: '泉灵的素养课'
      },
      component: () =>
        // import(/* webpackChunkName: "moreComment" */ '@/views/course/shoppingPolymerize');
        import(/* webpackChunkName: "moreComment" */ '@/views/course/polymerize')
    },
    // {
    //   path: 'polymerize',
    //   name: 'polymerize',
    //   meta: {
    //     title: '泉灵的素养课'
    //   },
    //   component: () =>
    //     import(/* webpackChunkName: "moreComment" */ '@/views/course/polymerize')
    // },
    {
      path: 'more-comment',
      name: 'moreComment',
      meta: {
        title: '课程评价'
      },
      component: () =>
        import(/* webpackChunkName: "moreComment" */ '@/views/course/moreComment')
    },

    {
      path: 'recommendCourse',
      name: 'recommendCourse',
      component: () =>
        import(/* webpackChunkName: "recommendCourse" */ '@/views/course/recommendCourse')
    },
    {
      path: 'get_recommend_flag',
      name: 'getRecommendFlag',
      meta: {
        auth: true
      },
      component: () =>
        import(/* webpackChunkName: "getRecommendFlag" */ '@/views/course/getRecommendFlag')
    },

    {
      path: 'course_group',
      name: 'courseGroupItem',
      component: () =>
        import(/* webpackChunkName: "courseGroupItem" */ '@/views/courseGroup'),
    },
    {
      path: 'login',
      name: 'Login',
      meta: {
        title: '少年得到服务号'
      },
      component: () =>
        import(/* webpackChunkName: "mallLogin" */ '@/views/login')
    },
    {
      path: 'success',
      name: 'Success',
      component: () =>
        import(/* webpackChunkName: "success" */ '@/views/success')
    },
    {
      path: 'ptSuccess',
      name: 'ptSuccess',
      component: () =>
        import(/* webpackChunkName: "groupSuccess" */ '@/views/success/ptSuccess')
    },
    {
      path: 'ybsuccess',
      name: 'ybsuccess',
      component: () =>
        import(/* webpackChunkName: "ybsuccess" */ '@/views/success/ybsuccess')
    },
    {
      path: 'outOrder',
      name: 'outOrder',
      component: Main,
      children: [{
        path: 'list',
        meta: {
          auth: true,
          title: '我的订单'
        },
        name: 'outOrderList',
        component: () =>
          import(/* webpackChunkName: "outOrderList" */ '@/views/outOrderList')
      }]
    },
    {
      path: 'JDalliance',
      name: 'JDalliance',
      component: () => import(/* webpackChunkName: "JDalliance" */ '@/views/JDalliance')
    },
    {
      path: 'order',
      name: 'Order',
      component: Main,
      children: [{
        path: 'detail',
        meta: {
          auth: true,
          title: '提交订单'
        },
        name: 'orderDetail',
        component: () =>
          import(/* webpackChunkName: "orderDetail" */ '@/views/orderDetail')
      },
      {
        path: 'list',
        meta: {
          auth: true,
          title: '我的订单'
        },
        name: 'orderList',
        component: () =>
          import(/* webpackChunkName: "orderList" */ '@/views/orderList')
      },
      {
        path: 'ptList',
        name: 'ptList',
        meta: {
          auth: true,
          title: '我的订单'
        },
        component: () =>
          import(/* webpackChunkName: "ptList" */ '@/views/ptOrderList')
      }]
    },
    {
      path: 'address',
      name: 'addressPart',
      component: Main,
      children: [{
        path: 'list',
        name: 'AddressList',
        meta: {
          auth: true,
          title: '我的收货地址'
        },
        component: () =>
          import('@/views/addressList')
      },
      {
        path: 'item/:type',
        name: 'NewOrEditAddress',
        meta: {
          auth: true
        },
        component: AddressItem
      },
      {
        path: 'add',
        name: 'NewAddress',
        meta: {
          auth: true,
          title: '添加地址'
        },
        component: AddressItem
      },
      {
        path: 'edit',
        name: 'EditAddress',
        meta: {
          auth: true,
          title: '编辑收货地址'
        },
        component: AddressItem
      }]
    },
    {
      path: 'mailAddressList',
      name: 'MailAddressList',
      meta: {
        auth: true,
        title: '收货地址'
      },
      component: () =>
        import(/* webpackChunkName: "mailAddressList" */ '@/views/mailAddress/list')
    },
    {
      path: 'mailAddressEdit',
      name: 'MailAddressEdit',
      meta: {
        auth: true,
        title: '收货地址'
      },
      component: () =>
        import(/* webpackChunkName: "mailAddressList" */ '@/views/mailAddress/editAddress')
    },
    {
      path: 'logisticsDetail',
      name: 'LogisticsDetail',
      meta: {
        auth: true
      },
      component: () => import('@/views/logisticsDetail')
    },
    // 单报优惠券列表
    {
      path: 'coupons',
      name: 'coupons',
      meta: {
        auth: true
      },
      component: () =>
        import(/* webpackChunkName: "coupons" */ '@/views/coupons')
    },
    // 购物车优惠券列表（购物车与单报优惠券使用上冲突，开发时间短，所以针对购物车下单新起了个路由）
    {
      path: 'coupons/list',
      name: 'couponsList',
      meta: {
        auth: true
      },
      component: () =>
        import(/* webpackChunkName: "couponsList" */ '@/views/coupons/list')
    },
    // 新的单报优惠券列表
    {
      path: 'coupon/list',
      name: 'CouponList',
      meta: {
        auth: true,
        title: '优惠券',
      },
      component: () =>
        import(/* webpackChunkName: "CouponList" */ '@/views/coupons/couponList')
    },
    // 新的购物车优惠券列表
    {
      path: 'coupon/cart/list',
      name: 'CouponCartList',
      meta: {
        auth: true,
        title: '优惠券',
      },
      component: () =>
        import(/* webpackChunkName: "CouponCartList" */ '@/views/coupons/couponCartList')
    },
    // 会员卡
    {
      path: 'vipCard',
      name: 'vipCard',
      meta: {
        title: '少年得到权益卡'
      },
      component: () =>
        import(/* webpackChunkName: "vipCard" */ '@/views/vipCard')
    },
    // 会员卡成功页

    // @aigc:start 2024/03/01-15:49
    {
      path: 'vipCard/success',
      name: 'vipCardSuccess',
      meta: {},
      component: () =>
        import(/* webpackChunkName: "vipCardSuccess" */ '@/views/vipCard/success')
    },
    // @aigc:end 2024/03/01-15:49

    // 会员优惠券列表

    // 购物车权益券列表
    // @aigc:start 2024/03/04-14:50
    {
      path: 'coupon/cart/member',
      name: 'CouponCartMember',
      meta: {
        auth: true,
        title: '权益券',
      },
      component: () =>
        import(/* webpackChunkName: "CouponCartMember" */ '@/views/coupons/vipCouponsCart')
    },
    // @aigc:end 2024/03/04-14:50

    // 单报会员优惠券列表
    // @aigc:start 2024/03/06-17:21
    {
      path: 'coupon/member',
      name: 'CouponMember',
      meta: {
        auth: true,
        title: '权益券',
      },
      component: () =>
        import(/* webpackChunkName: "CouponMember" */ '@/views/coupons/vipCoupons')
    },
    // @aigc:end 2024/03/06-17:21

    {
      path: 'campSuccess',
      name: 'campSuccess',
      component: () =>

        // import(/* webpackChunkName: "campSuccess" */ '@/views/success/trainingCampSuccess')
        import(/* webpackChunkName: "campSuccess" */ '@/views/success/newTrainingCampSuccess')
    },
    {
      path: 'groupBuySuccess',
      name: 'groupBuySuccess',
      component: () =>
        import(/* webpackChunkName: "groupBuySuccess" */ '@/views/success/groupBuySuccess')
    },
    {
      path: 'groupBuyShare',
      name: 'groupBuyShare',
      component: () =>
        import(/* webpackChunkName: "groupBuySuccess" */ '@/views/groupBuyShare')
    },
    {
      path: 'blank',
      name: 'blank',
      component: () =>
        import(/* webpackChunkName: "blank" */ '@/views/success/blank')
    },
    {
      path: 'activity',
      name: 'activity',
      component: Main,
      children: [{
        path: 'newCard',
        name: 'newCard',
        component: () =>
          import('@/views/activity/newCard/index.vue')
      },
      {
        path: 'newCardSuccess',
        name: 'newCardSuccess',
        meta: {
          title: '领取成功'
        },
        component: () =>
          import('@/views/activity/newCard/newCardSuccess.vue')
      }]
    },
    {
      path: 'cdkey',
      name: 'cdkey',
      component: Main,
      children: [
        {
          path: 'index',
          name: 'index',
          meta: {
            title: '兑换中心'
          },
          component: () =>
            import('@/views/cdkey/index.vue')
        },
        {
          path: 'exchangeCourse',
          name: 'exchangeCourse',
          meta: {
            title: '兑换课程'
          },
          component: () =>
            import('@/views/cdkey/exchangeCourse.vue')
        },
        {
          path: 'courseConfig',
          name: 'cdkeyCourseConfig',
          meta: {
            title: '确认兑换信息',
            auth: true
          },
          component: () =>
            import('@/views/cdkey/courseConfig.vue')
        }, {
          path: 'commonSuccess',
          name: 'commonSuccess',
          component: () =>
            import('@/views/cdkey/commonSuccess.vue')
        }, {
          path: 'refillCardOne',
          name: 'refillCardOne',
          meta: {
            title: '兑换'
          },
          component: () =>
            import('@/views/cdkey/refillCardOne.vue')
        }, {
          path: 'refillCardTwo',
          name: 'refillCardTwo',
          meta: {
            title: '兑换'
          },
          component: () =>
            import('@/views/cdkey/refillCardTwo.vue')
        }, {
          path: 'error',
          name: 'error',
          meta: {
            title: '兑换失败'
          },
          component: () =>
            import('@/views/cdkey/error.vue')
        }]
    },
    {
      path: 'qrCodeInfo',
      name: 'qrCodeInfo',
      meta: {
        title: '兑换'
      },
      component: () =>
        import(/* webpackChunkName: "blank" */ '@/views/qrCodeInfo')
    },
    {
      path: 'exchangeInfo',
      name: 'exchangeInfo',
      meta: {
        title: '兑换'
      },
      component: () =>
        import(/* webpackChunkName: "blank" */ '@/views/qrCodeInfo/exchange')
    },
    {
      path: 'exchangeSuccess',
      name: 'exchangeSuccess',
      meta: {
        title: '兑换'
      },
      component: () =>
        import(/* webpackChunkName: "blank" */ '@/views/qrCodeInfo/exchangeSuccess')
    },
    {
      path: 'insurance',
      name: 'insurance',
      component: Main,
      children: [
        {
          path: 'toB/cardPackage',
          name: 'cardPackage',
          meta: {
            title: '卡包'
          },
          component: () =>
            import('@/views/insurance/toB/cardPackage')
        },
        {
          path: 'toB/orderList',
          name: 'insuranceOrderList',
          meta: {
            title: '订单列表'
          },
          component: () =>
            import('@/views/insurance/toB/orderList')
        },
        {
          path: 'toB/orderDetail',
          name: 'insuranceOrderDetail',
          meta: {
            title: '订单详情'
          },
          component: () =>
            import('@/views/insurance/toB/orderDetail')
        },
        // {
        //   path: 'toB/getPackage',
        //   name: 'getPackage',
        //   meta: {
        //     title: '获取礼品包'
        //   },
        //   component: () =>
        //     import('@/views/insurance/toB/getPackage')
        // },
        {
          path: 'toB/packageDetail',
          name: 'packageDetail',
          meta: {
            title: '礼品包详情'
          },
          component: () =>
            import('@/views/insurance/toB/packageDetail')
        },
        {
          path: 'toB/getSuccess',
          name: 'getSuccess',
          meta: {
            title: '支付成功'
          },
          component: () =>
            import('@/views/insurance/toB/getSuccess')
        },
        {
          path: 'toC/giftDetail',
          name: 'giftDetail',
          meta: {
            title: '礼品详情'
          },
          component: () =>
            import('@/views/insurance/toC/giftDetail')
        },
        {
          path: 'toC/giftSuccess',
          name: 'giftSuccess',
          meta: {
            title: '成功领取礼品'
          },
          component: () =>
            import('@/views/insurance/toC/giftSuccess')
        }, {
          path: 'toC/receive',
          name: 'giftReceive',
          meta: {
            title: '礼品详情'
          },
          component: () =>
            import('@/views/insurance/toC/receive')
        }]
    },
    // 购物车
    {
      path: 'cart',
      name: 'shoppingCart',
      meta: {
        auth: true,
        title: '购物车'
      },
      component: () =>
        import(/* webpackChunkName: "cart" */ '@/views/shoppingCart/cart')
    },
    {
      path: 'crispyRice',
      name: 'crispyRice',
      component: () =>
        import(/* webpackChunkName: "crispyRice" */ '@/views/crispyRice')
    },
    {
      path: 'crispyRice/success',
      name: 'crispyRiceSuccess',
      meta: {
        title: '领取结果'
      },
      component: () =>
        import(/* webpackChunkName: "crispyRice" */ '@/views/crispyRice/success')
    },
    // 中转页
    {
      path: 'transitPage',
      name: 'transitPage',
      meta: {
        title: '少年得到'
      },
      component: () =>
        import(/* webpackChunkName: "crispyRice" */ '@/views/transitPage')
    },
    {
      path: 'curriculum',
      name: 'abtest',
      meta: {
        title: '少年得到'
      },
      component: () =>
        import('@/views/abtest/index')
    },
    // 我的邮寄单
    {
      path: 'logistics',
      name: 'logistics',
      meta: {
        title: '我的邮寄单'
      },
      component: () =>
        import(/* webpackChunkName: "logistics" */ '@/views/logistics')
    },
    {
      path: 'logistics/detail',
      name: 'logisticsDetail',
      meta: {
        title: '邮寄单详情'
      },
      component: () =>
        import(/* webpackChunkName: "logistics" */ '@/views/logistics/detail.vue')
    },
    {
      path: 'logistics/detailV2',
      name: 'logisticsDetail',
      meta: {
        title: '邮寄单详情'
      },
      component: () =>
        import(/* webpackChunkName: "logistics" */ '@/views/logistics/detailV2.vue')
    },
    // 营地
    {
      path: 'camp',
      name: 'camp',
      meta: {
        title: '研学课程'
      },
      component: () =>
        import(/* webpackChunkName: "camp" */ '@/views/course/camp')
    },
    // 全民转介绍
    {
      path: 'referral',
      name: 'referral',
      meta: {
        title: '全民转介绍'
      },
      component: () =>
        import(/* webpackChunkName: "referral" */ '@/views/referral/index')
    },
    // 用户自主提交开发票信息功能
    {
      path: 'selfInvoice',
      name: 'selfInvoice',
      meta: {
        title: '电子发票申请'
      },
      component: () =>
        import(/* webpackChunkName: "invoice" */ '@/views/selfInvoice/index')
    },
    // ai圈子
    {
      path: 'circle',
      name: 'AiCircle',
      meta: {
        title: ''
      },
      component: () =>
        import(/* webpackChunkName: "aiCircle" */ '@/views/circle')
    },
    // H5中转页
    {
      path: 'h5Transfer',
      name: 'h5Transfer',
      component: () =>
        import(/* webpackChunkName: "h5Transfer" */ '@/views/h5Transfer')
    },
  ]
},
{
  path: '/h5Pay/mall/insurance/toB/getPackage',
  name: 'getPackage',
  meta: {
    title: '获取礼品包'
  },
  component: () =>
    import('@/views/insurance/toB/getPackage')
},
{
  path: '/h5pay/mall',
  name: 'h5pay_mall',
  component: () =>
    import(/* webpackChunkName: "h5pay" */ '@/views/demo'),
},
{
  path: '/h5Pay/mall_training_camp_order',
  name: 'training_camp_order',
  meta: {
    title: '提交订单'
  },
  component: () =>
    import(/* webpackChunkName: "trainingCampOrder" */ '@/views/orderDetail/trainingCamp')
},
{
  path: '/h5Pay/mall_order',
  name: 'h5pay_order',
  meta: {
    auth: true,
    title: '提交订单',
  },
  component: () =>
    import(/* webpackChunkName: "h5payOrder" */ '@/views/orderDetail'),
},
{
  path: '/h5Pay/mall_lianbao_order',
  name: 'mall_lianbao_order',
  meta: {
    auth: true,
    title: '提交订单',
  },
  component: () =>
    import(

      /* webpackChunkName: "mallLianbaoOrder" */
      '@/views/orderDetail/lianbaoOrderDetail'
    ),
},
{
  path: '/h5Pay/mall_compatible_order',
  name: 'h5pay_compatible_order',
  component: () =>
    import(

      /* webpackChunkName: "h5payCompatibleOrder" */
      '@/views/compatibleOrderDetail'
    ),
},

];

export default routes;


// headimgurl: "http://thirdwx.qlogo.cn/mmopen/vi_32/AtbiaYIbc36L6JKVUJeS6qDShRiaN6cHQWYibgG3CK0duPOI0Lpz3ZJILEL1I6CnYGibvIseWNt6wNQD6ccnZrP2wA/132"
// nickname: "账号已注销"
// openid: "oqryG0V7EAwRQGOFpHZ4Om65uhlU"
// unionid: "oDQBv0-mtyTnldaIXW5rWV3ltCys"

// igc_h5_uuid  {"value":"6ad1d729-dbf1-4079-8c1d-ed3a6657ec02"}
// _igc_wx_openId_  oqryG0V7EAwRQGOFpHZ4Om65uhlU
// _igc_wx_unionId_  oDQBv0-mtyTnldaIXW5rWV3ltCys
// _igc_wx_headImgUrl_  http://thirdwx.qlogo.cn/mmopen/vi_32/AtbiaYIbc36L6JKVUJeS6qDShRiaN6cHQWYibgG3CK0duPOI0Lpz3ZJILEL1I6CnYGibvIseWNt6wNQD6ccnZrP2wA/132
// _igc_wx_nickName_  账号已注销
// _igc_wx_auth_retry_ 0
